import React, { useContext } from 'react';

import WidgetContext from '@totem/components/customDashboard/home/widgets/WidgetContext';
import MyTicketsContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/myTickets/myTicketsContainer';
import MyTicketsTable from '@totem/components/ticketing/myTickets/myTicketsTable';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const WidgetMyTickets = () => {
  const { onSetTitle, componentInstance } = useContext(WidgetContext);

  return (
    <InputContainer
      filterConfig={containerConfiguration}
      componentKey={`${componentInstance.componentInstanceId}`}
      componentLabel={`Dashboard: ${componentInstance.title}`}
      defaultSort={{
        field: 'createdAt',
        direction: 'descend',
      }}
      defaultFilters={[
        {
          field: 'status',
          values: ['OPEN', 'RESOLVED'],
        },
      ]}
    >
      <MyTicketsContainer
        onSetTotalRecords={(recordCount: number) =>
          onSetTitle(<RecordCountBadge count={recordCount} />)
        }
      >
        <MyTicketsTable />
      </MyTicketsContainer>
    </InputContainer>
  );
};

export default WidgetMyTickets;
